import React from 'react';
import { Box } from '@mafc/trolly';

import BlockTitle from 'common/BlockTitle';
import { useBreakpoints } from '@mafc/hooks';
import BinDiscountBanner from 'common/BinDiscountBanner';
import { useSelector } from 'react-redux';
import { IAppState } from '@mafc/common';
import useLayoutWidth from 'pages/Cart/hooks/useLayoutWidth';

interface Props {
  title?: React.ReactNode;
  children?: React.ReactNode;
  mb?: any[];
  pb?: any[];
  sx?: object;
  ShareCart?: React.ReactNode;
  Promo?: React.ReactNode;
  PaymentMethods?: React.ReactNode;
  bg?: string;
  paddingStyle?: string;
  isCheckoutPage?: boolean;
  hideBinLoading?: boolean;
}

const OrderSummaryLayout: React.FC<Props> = ({
  title,
  children,
  ShareCart,
  Promo,
  PaymentMethods,
  hideBinLoading = true,
  bg = '',
  paddingStyle = [0, 3],
  isCheckoutPage = false,
  ...rest
}) => {
  const { isMobile } = useBreakpoints();
  const { countryConfiguration = {} } = useSelector((state: IAppState) => state && state.appConfig);
  const { cart: { isBinSupported = '' } = {} } = countryConfiguration;
  const desktopWidth = useLayoutWidth(true);
  return (
    <Box
      width={[1, 1, 1, desktopWidth]}
      m={0}
      {...rest}
      data-testid="__checkout_order_summary_container__"
    >
      {!isCheckoutPage && isBinSupported && <BinDiscountBanner hideBinLoading={hideBinLoading} />}
      {!!ShareCart && ShareCart}
      {!!Promo && Promo}
      {(!isMobile || isCheckoutPage) && <BlockTitle>{title}</BlockTitle>}
      <Box as="div" p={paddingStyle} mx={[null, 4, null, 0]} bg={bg}>
        {children}
      </Box>

      {!isMobile && PaymentMethods && PaymentMethods}
    </Box>
  );
};

export default OrderSummaryLayout;
